import React, { useState, useContext } from "react";
import { CartContext } from "../context/CartContext";

const Qty = ({ item }) => {
  const { handleSelect, handleInput } = useContext(CartContext);
  const [open, setOpen] = useState(false);

  const options = [...Array(10).keys()].map(i => i + 1).concat(["10+"]);

  return (
    <div className="w-[140px] relative">
      {item.amount < 10 ? (
        <div className="relative">
          <button
            onClick={() => setOpen(!open)}
            className="w-full h-12 px-4 flex justify-between items-center rounded-xl bg-gray-900 border border-gray-600 text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-yellow-400 transition"
          >
            {item.amount}
            <span className="ml-2 transition-transform duration-200">{open ? "▲" : "▼"}</span>
          </button>

          {open && (
            <ul className="absolute w-full mt-1 max-h-48 overflow-auto bg-gray-900 border border-gray-600 rounded-xl z-20 shadow-lg">
              {options.map((opt, idx) => (
                <li
                  key={idx}
                  onClick={() => {
                    handleSelect({ target: { value: opt } }, item.id);
                    setOpen(false);
                  }}
                  className="px-4 py-2 cursor-pointer text-white hover:bg-yellow-400 hover:text-gray-900 transition"
                >
                  {opt}
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : (
        <input
          onBlur={(e) => handleInput(e, item.id)}
          className="w-full h-12 p-3 rounded-xl border border-gray-600 bg-gray-900/80 text-white placeholder:text-gray-400 outline-none focus:ring-2 focus:ring-yellow-400 transition-all duration-300"
          type="text"
          placeholder={`${item.amount}`}
        />
      )}
    </div>
  );
};

export default Qty;
